import { nbsp } from "constants/InputRules";
import type { ReactNode } from "react";

interface ContenuProps {
  count: number;
}

function ReaffectationEPCI({ count }: Readonly<ContenuProps>): ReactNode {
  return count === 1 ? (
    <>Voulez-vous réaffecter le transfert sélectionné à l'EPCI sélectionné{nbsp}?</>
  ) : (
    <>
      Voulez-vous réaffecter les <b>{count}</b> transferts sélectionnés à l'EPCI sélectionné
      {nbsp}?
    </>
  );
}

function IndirectDirect({ count }: Readonly<ContenuProps>): ReactNode {
  return count === 1 ? (
    <>Voulez-vous réaffecter le transfert sélectionné en affectation directe{nbsp}?</>
  ) : (
    <>
      Voulez-vous réaffecter les <b>{count}</b> transferts sélectionnés en affectation directe{nbsp}
      ?
    </>
  );
}

function ModificationDates({ count }: Readonly<ContenuProps>): ReactNode {
  return count === 1 ? (
    <>Voulez-vous modifier les dates renseignées pour le transfert sélectionné{nbsp}?</>
  ) : (
    <>
      Voulez-vous modifier les dates renseignées pour les <b>{count}</b> transferts sélectionnés
      {nbsp}?
    </>
  );
}

function SuppressionTransfert({ count }: Readonly<ContenuProps>): ReactNode {
  return count === 1 ? (
    <>
      Êtes-vous sûr(e) de vouloir supprimer le transfert sélectionné{nbsp}?
      <br />
      Ce transfert sera supprimé <b>définitivement</b>.
    </>
  ) : (
    <>
      Êtes-vous sûr(e) de vouloir supprimer les transferts sélectionnés{nbsp}?
      <br />
      Ces transferts seront supprimés <b>définitivement</b>.
    </>
  );
}

function ReaffectationPerimetre({ count }: Readonly<ContenuProps>): ReactNode {
  return count === 1 ? (
    <>Voulez-vous réaffecter le transfert sélectionné au Périmètre SDEA sélectionné{nbsp}?</>
  ) : (
    <>
      Voulez-vous réaffecter les <b>{count}</b> transferts sélectionnés au Périmètre SDEA
      sélectionné{nbsp}?
    </>
  );
}

const TransfertEditionDialogMessages = {
  ReaffectationEPCI,
  DirectIndirect: ReaffectationEPCI,
  IndirectDirect,
  ModificationDates,
  SuppressionTransfert,
  ReaffectationPerimetre,
};

export default TransfertEditionDialogMessages;
